import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  getEmail: "",
  getStatus: "",
  getRole: "",
};
const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    getEmailVal: (state, action) => {
      state.getEmail = action.payload;
    },
    getStatus: (state, action) => {
      state.getStatus = action.payload;
    },
    getRole: (state, action) => {
      state.getRole = action.payload;
    },
  },
});

export default authSlice;
export const authSliceActions = authSlice.actions;
